import { NumberField } from "./NumberField";
import { PanelSection } from "./PanelSection";

interface AppearanceSectionProps {
  opacity: number | "mixed";
  disabled: boolean;
  onOpacityCommit: (opacity: number) => void;
}

export function AppearanceSection({ opacity, disabled, onOpacityCommit }: AppearanceSectionProps) {
  return (
    <PanelSection title="Appearance">
      <NumberField
        label="%"
        value={opacity === "mixed" ? 100 : opacity * 100}
        mixed={opacity === "mixed"}
        min={0}
        max={100}
        onCommit={value => {
          if (!disabled) {
            onOpacityCommit(clamp(value, 0, 100) / 100);
          }
        }}
      />
    </PanelSection>
  );
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
